import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class CatalogoPdfClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async upload(file) {
    try {
      const formData = new FormData();
      formData.append('arquivo', file);
      const { data } = await this.api.post('/catalogo-pdf/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao enviar o catálogo em PDF');
    }
  }
}
